import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App.jsx";
import { setupFetchAuthInterceptor } from "./utils/setupFetchInterceptor";

// Install fetch interceptor before anything else renders
setupFetchAuthInterceptor();

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
